import { useConfig } from '@@/auto/services/useConfig';

import LayoutSelfService, { TLayoutSelfService } from './LayoutSelfService';

export default function LayoutSelfServiceForTenant(props: TLayoutSelfService) {
  const {
    config: { layoutSelfServiceConfig },
  } = useConfig();

  return <LayoutSelfService {...layoutSelfServiceConfig} {...props} />;
}

export type { TLayoutSelfService };
